import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "nav-container" }
const _hoisted_3 = { class: "nav-menu" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "nav-right" }
const _hoisted_6 = ["href"]

import { cookieHelper } from "@/common/CookieHelper";
  // 导航项数据
import { Options, Vue } from 'vue-class-component';
 import { Location, Document, Setting, Menu, ArrowRight } from "@element-plus/icons-vue"
 import { createApp, ref, computed, watch, onMounted } from "vue";
 import {
GetListNewsClass
} from "../../httpRequest/newsRequest";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  Headerscontent: {
    type: String,
    required: false,
    default: ''
  }
},
  setup(__props) {

  const navItems = [
  { name: '首页' },
  { name: '公司动态' },
  { name: '产品介绍' },
  { name: '服务支持' },
  { name: '解决方案' },
  { name: '联系我们' },
  { name: '合作伙伴' }
]

;
 const   isLogin = ref(false)  
const originalData = ref([]);
const props = __props

const GetListNewsClassData = async (data: any) => {
  var getListBusinessCategory = await GetListNewsClass({
    ParentId: data
  });
   
  originalData.value = getListBusinessCategory.data;
    
    setHomeSEO(props.Headerscontent)
};
const setHomeSEO= async (data: any) => {
  // 找到 首页 数据
  const home = originalData.value.find(item => item.newsClassName === data)
  
  if (!home) return

  // 设置标题
  document.title = home.newsClassTitle || '公司网站'

  // 设置关键词
  const kwMeta = document.querySelector('meta[name="keywords"]')
  if (kwMeta) kwMeta.content = home.newsClassKey

  // 设置描述
  const descMeta = document.querySelector('meta[name="description"]')
  if (descMeta) descMeta.content = home.newsClassDescribe
}

onMounted(() => {
  GetListNewsClassData("8c0faa9739096fbe4d7deedeab9cd181");
    var token = cookieHelper.getCookie("token");
 isLogin.value =cookieHelper.getCookie("token") ? true : false;
 
 
 
 
})
 const currentPage = ref('首页')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("span", { class: "logo-text" }, [
          _createElementVNode("img", { src: "favicon.ico" })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(originalData.value, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.newsClassName,
            href: item.routePath,
            class: _normalizeClass(["nav-item", { active: __props.Headerscontent === item.newsClassName }])
          }, _toDisplayString(item.newsClassName), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "member-login",
          href: isLogin.value ? '#/console' : '#/login'
        }, _toDisplayString(isLogin.value ? '我的控制台' : '会员登录'), 9, _hoisted_6)
      ])
    ])
  ]))
}
}

})